import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import GoogleMapComponent from "../GoogleMapComponent";
import AlertMessage from "../include/AlertMessage";
import { useAuth } from "../../context/AuthContext";
import { storage, ID, Permission, Role } from "../../appwrite/config";
var _ = require('lodash');


function AddEvent() {
    const { role, user } = useAuth();
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({ imageID: [], userid: '', name: '', price: '', expiryDate: '', eventDate: '', latitude: '', longitude: '', description: '', isActive: false });
    const [errors, setErrors] = useState({});
    const [images, setImages] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const redirectHistory = useNavigate();

    const token = sessionStorage.getItem('JWT_TOKEN');

    useEffect(() => {
        document.documentElement.className = "";
        if (role === "event" && user?.$id) {
            setFormData(prev => ({
                ...prev,
                userid: user.$id
            }));
        }

        fetchAllUsers();
        setLoading(false);
    }, []);


    //Get all users having the event role.
    const fetchAllUsers = async () => {
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listallusers`, {
                params: {
                    roleType: "event"
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }

            });

            const data = await response.data.data;            
            if (Array.isArray(data) && data.length > 0) {
                setAllUsers(data);
            } else {
                setAllUsers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    }

    const handleLocationSelect = ({ lat, lng }) => {
        setFormData((prev) => ({
            ...prev,
            latitude: lat,
            longitude: lng,
        }));
    };


    const handleFileChange = async (e) => {
        e.preventDefault();

        const selectedFiles = Array.from(e.target.files);

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        const maxSize = 5 * 1024 * 1024; // ✅ 2MB

        let validFiles = [];
        let invalidFiles = [];

        selectedFiles.forEach(file => {

            // ❌ Type validation
            if (!allowedTypes.includes(file.type)) {
                invalidFiles.push(file.name + " (invalid type)");
                return;
            }

            // ❌ Size validation
            if (file.size > maxSize) {
                invalidFiles.push(file.name + " (too large)");
                return;
            }

            // ✅ Valid file
            validFiles.push(file);
        });

        // ❌ Show error if any invalid files
        if (invalidFiles.length > 0) {
            setAlert({
                type: "error",
                message: `Some files are invalid: ${invalidFiles.join(", ")}`
            });
        }

        // ✅ Add only valid images
        const newImages = validFiles.map(file => ({
            url: URL.createObjectURL(file),
            file: file,
            isNew: true
        }));

        setImages(prev => [...prev, ...newImages]);
    };

    const handleRemoveImage = (index) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (!confirmDelete) return;

        const updatedImages = images.filter((_, i) => i !== index);
        setImages(updatedImages);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.description) newErrors.description = "Description is required.";
        if (!formData.latitude) newErrors.latitude = "Latitude is required.";
        if (!formData.longitude) newErrors.longitude = "Longitude is required.";
        if (!formData.expiryDate) newErrors.expiryDate = "Expiry Date is required.";
        if (!formData.price) newErrors.price = "Price is required.";
        if (!formData.eventDate) newErrors.eventDate = "Event Date is required.";


        return newErrors;
    };

    const handleEventAdd = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            try {
                setLoading(true);
                const uploadPromises = images.map(img =>
                    storage.createFile(
                        process.env.REACT_APP_BUCKET_ID,
                        ID.unique(),
                        img.file,
                        [
                            Permission.read(Role.any()),
                            Permission.write(Role.any())
                        ]
                    )
                );

                const uploadedFiles = await Promise.all(uploadPromises);
                const fileIds = uploadedFiles.map(file => file.$id);

                //API URL
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/addevent                                                                                                                                                                                                                                        `, {
                    "imageID": fileIds,
                    "name": formData.name,
                    "description": formData.description,
                    "latitude": formData.latitude,
                    "longitude": formData.longitude,
                    "expiryDate": formData.expiryDate,
                    "price": formData.price,
                    "eventDate": formData.eventDate,
                    "isActive": formData.isActive,
                    "userid": formData.userid
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Event added successfully!" });
                    setTimeout(() => redirectHistory('/events'), 2500); // thoda delay deke redirect  
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to add event. Please try again");
                setAlert({ type: "error", message: apierror });

            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }

        }
    }

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/Events" className='btn btn-primary'>Events</Link></li>
                        <li>Add</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Add Event
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (

                                <form onSubmit={handleEventAdd}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        {["admin"].includes(role) ? (
                                            <div className="field">
                                                <label className="label">User </label>
                                                <div className="control">
                                                    <div className="select">
                                                        <select id="userid" value={formData.userid} onChange={e => setFormData({ ...formData, userid: e.target.value })}>
                                                            <option value={''}>---Select---</option>
                                                            {allUsers.map((user, index) => (
                                                                <option value={user.$id}>{user.name}</option>
                                                            ))}
                                                        </select>
                                                        {errors.userid && <p className="help" style={{ color: 'red' }}>{errors.userid}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <input type="hidden" id="userid" value={formData.userid} onChange={e => setFormData({ ...formData, userid: e.target.value })} />
                                        )}
                                    </div>

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="name" type="text" placeholder="Name" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
                                            </div>
                                            {errors.name && <p className="help" style={{ color: 'red' }}>{errors.name}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label" htmlFor="price">Price <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="price" type="text" placeholder="Price" value={formData.price} onChange={e => setFormData({ ...formData, price: e.target.value })} />
                                            </div>
                                            {errors.price && <p className="help" style={{ color: 'red' }}>{errors.price}</p>}
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="latitude">Latitude <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" readOnly id="latitude" type="text" placeholder="Latitude" value={formData.latitude} onChange={e => setFormData({ ...formData, latitude: e.target.value })} />
                                            </div>
                                            {errors.latitude && <p className="help" style={{ color: 'red' }}>{errors.latitude}</p>}
                                        </div>

                                        <div className="field">
                                            <label className="label" htmlFor="longitude">Longitude <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" readOnly id="longitude" type="text" placeholder="Longitude" value={formData.longitude} onChange={e => setFormData({ ...formData, longitude: e.target.value })} />
                                            </div>
                                            {errors.longitude && <p className="help" style={{ color: 'red' }}>{errors.longitude}</p>}
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label className="label" htmlFor="description">Description <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <textarea className="textarea" id="description" placeholder="Description" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} ></textarea>
                                        </div>
                                        {errors.description && <p className="help" style={{ color: 'red' }}>{errors.description}</p>}
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="expiryDate">Expire Date <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="expiryDate" type="date" placeholder="Expire Date" value={formData.expiryDate} onChange={e => setFormData({ ...formData, expiryDate: e.target.value })} />
                                            </div>
                                            {errors.expiryDate && <p className="help" style={{ color: 'red' }}>{errors.expiryDate}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label" htmlFor="eventDate">Event Date <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="eventDate" type="date" placeholder="Event Date" value={formData.eventDate} onChange={e => setFormData({ ...formData, eventDate: e.target.value })} />
                                            </div>
                                            {errors.eventDate && <p className="help" style={{ color: 'red' }}>{errors.eventDate}</p>}
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">&nbsp;</label>
                                            <div className="control">
                                                <label className="checkbox label"><input type="checkbox" name="isActive" id="isActive" checked={formData.isActive} onChange={e => setFormData({ ...formData, isActive: e.target.checked })} />
                                                    <span className="check"></span>
                                                    <span className="control-label">Active</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="field">
                                            <label className="label">Image</label>
                                            <div className="control">
                                                <input className="input" id="simage" accept="image/*" type="file" multiple onChange={handleFileChange} />
                                            </div>
                                            {errors.simage && <p className="help" style={{ color: 'red' }}>{errors.simage}</p>}
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-1 sm:grid-cols-1 sm:mb-3">
                                        {/* 🆕 IMAGE PREVIEW CARD SECTION */}
                                        {images.length > 0 && (
                                            <div className="card">
                                                <header className="card-header">
                                                    <p className="card-header-title">
                                                        Image Preview
                                                    </p>
                                                </header>

                                                <div className="card-content">
                                                    <div style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "15px"
                                                    }}>
                                                        {images.map((img, i) => (
                                                            <div key={i} style={{
                                                                position: "relative",
                                                                width: "120px",
                                                                height: "100px"
                                                            }}>
                                                                {/* 🆕 DELETE BUTTON */}
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleRemoveImage(i)}
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-8px",
                                                                        right: "-8px",
                                                                        background: "red",
                                                                        color: "#fff",
                                                                        border: "none",
                                                                        borderRadius: "50%",
                                                                        width: "22px",
                                                                        height: "22px",
                                                                        cursor: "pointer",
                                                                        fontSize: "12px",
                                                                        zIndex: 10
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>

                                                                {/* IMAGE */}
                                                                <img
                                                                    src={img.url}
                                                                    alt="preview"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "cover",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #ddd"
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>


                                    <div className="field">
                                        <div className="control">
                                            {/* <GoogleMapComponent onLocationSelect={handleLocationSelect} /> */}
                                            <GoogleMapComponent onLocationSelect={handleLocationSelect} />
                                        </div>
                                    </div>
                                    <div class="flex justify-center items-center">
                                        <div class="field grouped">
                                            <div class="control">
                                                <button type="submit" class="button green">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddEvent;